<template>
	<div class="header-bot ">
		<div class="header-bot_inner_wthreeinfo_header_mid">
			<div class="col-md-12 header-middle dir-rtl search-bar py-1" style="    display: flex;">
				<div class="form-group form-group-lg search-input" style="margin-bottom: 0;width: 100%;">
					<form autocomplete="off">
						<label style="top: 9px !important"><i class="fa fa-search" style="cursor: text;"
								aria-hidden="true"></i></label>
						<input class="form-control input-group-lg dir-rtl pr-2"
							style="background: white;height: fit-content;font-size: 14px !important;" type="text"
							placeholder="جستجو در فروشگاه ها و محصولات" v-model="textSearch" @focus="toggleShowUl(1)">
						<input type="submit" class="d-none" />
					</form>
				</div>
				<ul class="list-group search-suggestion prd-none1" id="searchResultUl">
					<li class="list-group-item " v-for="sritem in resultSearch" :key="sritem.id" @click="toggleShowUl(2)" >
						<div class="form-group" v-if="sritem.type == 'Store'" @click="goPage('StoreElement',sritem.id)">
							<label style="margin-left: 5px;">
								<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
									class="bi bi-shop" viewBox="0 0 16 16">
									<path
										d="M2.97 1.35A1 1 0 0 1 3.73 1h8.54a1 1 0 0 1 .76.35l2.609 3.044A1.5 1.5 0 0 1 16 5.37v.255a2.375 2.375 0 0 1-4.25 1.458A2.371 2.371 0 0 1 9.875 8 2.37 2.37 0 0 1 8 7.083 2.37 2.37 0 0 1 6.125 8a2.37 2.37 0 0 1-1.875-.917A2.375 2.375 0 0 1 0 5.625V5.37a1.5 1.5 0 0 1 .361-.976l2.61-3.045zm1.78 4.275a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0 1.375 1.375 0 1 0 2.75 0V5.37a.5.5 0 0 0-.12-.325L12.27 2H3.73L1.12 5.045A.5.5 0 0 0 1 5.37v.255a1.375 1.375 0 0 0 2.75 0 .5.5 0 0 1 1 0zM1.5 8.5A.5.5 0 0 1 2 9v6h1v-5a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5h6V9a.5.5 0 0 1 1 0v6h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1V9a.5.5 0 0 1 .5-.5zM4 15h3v-5H4v5zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3zm3 0h-2v3h2v-3z" />
								</svg>
							</label>
							<div class="d-inline-block"  style="vertical-align:sub;">{{ sritem.name }} </div>
						</div>
						<div class="form-group" v-else @click="goPage('Single',sritem.id)">
							<img :src="'https://radap.ir/'+sritem.img_url" width="30" height="30" style="max-height: 30px;min-height: 30px;"/>
							<div class="d-inline-block" >{{ sritem.name }}</div>
							<small style="font-size:10px" v-if="!route.params.id"> ({{ sritem.supplier_name }})</small>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<input type="hidden" id="locationHeaderTemp" />
	<input type="hidden" id="locationCoordinatesHeaderTemp" />
</template>

<script setup>
import { ref, watch } from 'vue';
import axios from 'axios';
import { useRoute } from 'vue-router';
import router from '@/router';
let textSearch = ref();
let resultSearch = ref([]);
let route = useRoute();
let param_id = ref('a0');
let city = ref();
getCityLocalStorage()
watch(textSearch, () => {
	async function doSearch() {
		if (textSearch.value.length >= 2) {
			if (route.name == 'StoreElement') {
				param_id.value = parseInt(route.params.id);
			}
			let response = await fetch('https://radap.ir/Backend/api/section/pages/main/search.php?text=' + textSearch.value + '&param=' + param_id.value + '&cityId=' + city.value)
			let data = await response.json()
				resultSearch.value = data;
		} else {
			resultSearch.value = '';
		}
	}

	doSearch()
})
function toggleShowUl(flag) {
	if (flag == 1) {
		document.getElementById('searchResultUl').classList.remove('d-none')
	} else {
		document.getElementById('searchResultUl').classList.add('d-none')
	}
	window.scrollTo(0, 0);
}
function getCityLocalStorage() {
	if (JSON.parse(localStorage.getItem('city')) !== null) {
		city.value = JSON.parse(localStorage.getItem('city'))[0]['city']
	} else {
		city.value = 1
	}
}
function goPage(type,id){
	// <router-link class="list-router-item" :to="{ name: 'StoreElement', params: { id: sritem.id } }" style="vertical-align:sub;">{{ sritem.name }} </router-link>
	// <router-link class="list-router-item" :to="{ name: 'Single', params: { item: sritem.id } }">{{ sritem.name }}</router-link>
	if(type == 'StoreElement'){
		router.push({name:'StoreElement',params:{id:id}})
	}else{
		router.push({name:'Single',params:{item:id}})
	}
}
</script>

<style scoped>
.head-line {
	vertical-align: super;
}

.navbar-fixed-top {
	top: 0;
	border-width: 0 0 1px;
	position: fixed;
	right: 0;
	left: 0;
	z-index: 1030;
}

@media (max-width: 992px) {
	.search-bar {
		position: sticky;
		z-index: 1;
		top: 0;
	}
}

@media (max-width:991px) {
	.logo_agile {
		width: 88%;
		text-align: center;
		float: none;
	}

	.agileits-social {
		display: none;
	}
}

ul {
	padding-inline-start: 0;
	list-style-type: none;
}

ul li {
	padding-inline-start: 15px;
	/* height: 20px; */
}

dl,
ol,
ul {
	margin-top: 0;
	margin-bottom: 1rem;
}

.search-suggestion {
	position: absolute;
	top: 100%;
	z-index: 1000;
	width: 90%;
	margin: 2px 0 0;
	background-color: #fff;
	border-radius: 2px;
	background-clip: padding-box;
	max-height: 200px;
	overflow: auto;
	border-radius: 4px;
}

.prd-none {
	display: none !important;
}

.list-router-item {
	color: black;
	text-decoration: none;
}

.search-input>label {
	position: absolute;
	margin-right: 8px;
	top: 12px;
	font-size: 15px;
	font-weight: 500;
	color: #a3a3a3;
	padding-left: 6px;
}

.text-truncate {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.header-bot {
	background-color: #fff;
}



.align-center {
	display: flex !important;
	-webkit-box-align: center !important;
}


.esoEaf {
	/* position: absolute; */
	color: rgb(117 126 173);
	top: 6.2rem;
	right: 0.8rem;
	-webkit-box-pack: start;
	justify-content: start;
}

.dBNnTd {
	border-radius: 50%;
	margin-left: 0.8rem;
	box-shadow: rgb(0 0 0 / 40%) 0px 0.4rem 1.5rem -0.5rem;
	background-color: rgb(255, 255, 255);
	overflow: hidden;
	width: 3.2rem;
	height: 3.2rem;
	padding: 0.3rem;
}

.dBNnTd img {
	max-width: 100%;
	height: auto;
	display: block;
}


.esoEaf span {
	width: 5rem;
	display: none;
}

.esoEaf strong {
	margin-right: 0px;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	max-width: 45%;
}

.esoEaf button {
	background: rgb(255, 255, 255);
	color: rgb(117 126 173);
	font-size: 0.8rem;
	border-radius: 1.4rem;
	margin-right: 1.4rem;
	padding: 0.4rem 0.8rem 0.3rem 1rem;
	width: auto;
	max-width: 10rem;
	white-space: nowrap;
	height: 2.1rem;
	overflow: hidden;
}

.align-center {
	display: flex !important;
	-webkit-box-align: center !important;
	align-items: center !important;
}

.no-effect-button {
	display: inherit;
	cursor: pointer;
	background: transparent;
	border: none !important;
}

@media (min-width: 992px) {
	.dBNnTd {
		width: 5.4rem;
		height: 5.4rem
	}
}

@media (min-width: 768px) {
	.esoEaf {
		top: 8rem;
		right: 1.5rem;
	}

	.dBNnTd {
		width: 4.5rem;
		height: 4.5rem;
	}
}

@media (min-width: 576px) {
	.esoEaf strong {
		margin-right: 0.8rem;
	}

	.esoEaf span {
		width: auto;
		display: block;
	}

	.esoEaf button {
		margin-right: 1.6rem;
		width: 8.9rem;
		height: 2.3rem;
		font-size: 1rem;
	}
}

@media (max-width: 640px) {

	.sc-1isyov5-1 span,
	.sc-1isyov5-1 strong {
		display: none;
	}
}</style>